import { MetadataStorage } from './MetadataStorage';

/**
 * Default metadata storage is used as singleton and can be used to store all metadatas.
 */
export const DEFAULT_METADATA_STORAGE = new MetadataStorage();